module.exports = __webpack_public_path__ + "static/media/4S.e1ae3152.svg";